// Track how many sheets/numpads are mounted at once; toggle `body.has-sheet`
// while at least one is present so CSS can shrink the app shell.
let count = 0
const CLASS = 'has-sheet'

export function pushSheet() {
  count++
  if (count === 1) document.body.classList.add(CLASS)
}

export function popSheet() {
  count--
  if (count <= 0) {
    count = 0
    document.body.classList.remove(CLASS)
  }
}
